var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested, IsEmail, IsArray, IsPhoneNumber, ValidateIf, IsNotEmpty, Matches, Validate, } from "class-validator";
import { ConsentStatus, ConsentType, IdentifiedPatientLastActivityType, IdentifiedPatientState, RequestConsentError } from "./consent.dtos";
import { SearchInput } from "./search.dtos";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
import { PatientNotificationType, StudyVersionLiteDto } from "./study.dtos";
import { ValidateNPICode } from "./npicode.validator";
const EXTERNAL_ID_NOT_EMPTY_MESSAGE = "externalId must not be empty";
export class ConditionDescription {
}
__decorate([
    IsString()
], ConditionDescription.prototype, "code", void 0);
__decorate([
    IsString()
], ConditionDescription.prototype, "description", void 0);
export var PatientGender;
(function (PatientGender) {
    PatientGender["MALE"] = "male";
    PatientGender["FEMALE"] = "female";
    PatientGender["OTHER"] = "other";
    PatientGender["UNKNOWN"] = "unknown";
})(PatientGender || (PatientGender = {}));
export class StudyRecruitmentDto {
}
__decorate([
    IsString()
], StudyRecruitmentDto.prototype, "id", void 0);
__decorate([
    Type(() => SearchInput),
    ValidateNested(),
    IsOptional()
], StudyRecruitmentDto.prototype, "query", void 0);
__decorate([
    Type(() => ConditionDescription),
    ValidateNested({ each: true }),
    IsOptional()
], StudyRecruitmentDto.prototype, "conditionDescriptions", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], StudyRecruitmentDto.prototype, "lastUpdated", void 0);
export class UpdateRecruitmentInput {
}
__decorate([
    Type(() => SearchInput),
    ValidateNested(),
    IsOptional()
], UpdateRecruitmentInput.prototype, "query", void 0);
__decorate([
    Type(() => ConditionDescription),
    ValidateNested({ each: true }),
    IsOptional()
], UpdateRecruitmentInput.prototype, "conditionDescriptions", void 0);
export class IdentifiedPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], IdentifiedPatientDto.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "phone", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdentifiedPatientDto.prototype, "noDataAccess", void 0);
__decorate([
    IsString()
], IdentifiedPatientDto.prototype, "organizationName", void 0);
__decorate([
    IsEnum(IdentifiedPatientState)
], IdentifiedPatientDto.prototype, "state", void 0);
__decorate([
    IsEnum(IdentifiedPatientState)
], IdentifiedPatientDto.prototype, "addBackState", void 0);
__decorate([
    IsBoolean()
], IdentifiedPatientDto.prototype, "hasPrescreenConsented", void 0);
__decorate([
    IsBoolean()
], IdentifiedPatientDto.prototype, "dataDeliveryAllowed", void 0);
__decorate([
    IsEnum(RequestConsentError),
    IsOptional()
], IdentifiedPatientDto.prototype, "prescreeningRequestNotAllowedReason", void 0);
__decorate([
    IsEnum(RequestConsentError),
    IsOptional()
], IdentifiedPatientDto.prototype, "enrollmentRequestNotAllowedReason", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdentifiedPatientDto.prototype, "interested", void 0);
__decorate([
    IsDate(),
    IsOptional()
], IdentifiedPatientDto.prototype, "interestedUpdated", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdentifiedPatientDto.prototype, "contacted", void 0);
__decorate([
    IsDate(),
    IsOptional()
], IdentifiedPatientDto.prototype, "contactedUpdated", void 0);
__decorate([
    IsEnum(IdentifiedPatientLastActivityType),
    IsOptional()
], IdentifiedPatientDto.prototype, "lastActivityType", void 0);
__decorate([
    IsDate(),
    IsOptional()
], IdentifiedPatientDto.prototype, "lastActivityDate", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "externalId", void 0);
__decorate([
    IsString(),
    IsOptional()
], IdentifiedPatientDto.prototype, "revocationReason", void 0);
__decorate([
    Type(() => StudyVersionLiteDto),
    ValidateNested(),
    IsOptional()
], IdentifiedPatientDto.prototype, "consentedStudyVersion", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdentifiedPatientDto.prototype, "updateRecordsNeeded", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdentifiedPatientDto.prototype, "patientAccountDeleted", void 0);
export class IdentifiedPatientsResponseDto {
}
__decorate([
    IsNumber()
], IdentifiedPatientsResponseDto.prototype, "total", void 0);
__decorate([
    Type(() => IdentifiedPatientDto),
    ValidateNested({ each: true })
], IdentifiedPatientsResponseDto.prototype, "patients", void 0);
export class IdentifiedPatientSummary {
}
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "NO_PRESCREEN_CONSENT", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "PRESCREEN_CONSENT_PENDING", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "PRESCREEN_CONSENTED", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "READY_TO_ENROLL", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "ENROLLING", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "ENROLLED", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "DECLINED_PRESCREEN", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "DECLINED_ENROLLMENT", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], IdentifiedPatientSummary.prototype, "REMOVED", void 0);
export class UpdateIdentifiedPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "removed", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "phone", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "interested", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "contacted", void 0);
__decorate([
    IsEnum(IdentifiedPatientLastActivityType),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "lastActivityType", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Matches(/\S/, { message: EXTERNAL_ID_NOT_EMPTY_MESSAGE })
], UpdateIdentifiedPatientDto.prototype, "externalId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode)
], UpdateIdentifiedPatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "updateRecordsNeeded", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateIdentifiedPatientDto.prototype, "signedExternalId", void 0);
export class RecruitmentOverviewStats {
}
__decorate([
    IsObject()
], RecruitmentOverviewStats.prototype, "totalStats", void 0);
export function initIdentifiedPatientStateCounts() {
    return {
        INFORMATION_SENT: 0,
        PRESCREEN_CONSENT_PENDING: 0,
        PRESCREEN_CONSENTED: 0,
        ENROLLING: 0,
        ENROLLING_INTERESTED: 0,
        ENROLLING_CONTACTED: 0,
        ENROLLED: 0,
        DECLINED_PRESCREEN: 0,
        DECLINED_ENROLLMENT: 0,
        REVOKED_PRESCREEN: 0,
        REVOKED_ENROLLMENT: 0,
        REMOVED: 0,
    };
}
export class PatientConsentCount {
}
__decorate([
    IsEnum(ConsentType)
], PatientConsentCount.prototype, "consentType", void 0);
__decorate([
    IsEnum(ConsentStatus)
], PatientConsentCount.prototype, "consentStatus", void 0);
__decorate([
    IsNumber()
], PatientConsentCount.prototype, "count", void 0);
export class RecruitmentWhatsNew {
}
__decorate([
    Type(() => PatientConsentCount),
    ValidateNested({ each: true })
], RecruitmentWhatsNew.prototype, "patientConsentCounts", void 0);
export var ContactPreferenceType;
(function (ContactPreferenceType) {
    ContactPreferenceType["EMAIL"] = "email";
    ContactPreferenceType["PHONE"] = "phone";
})(ContactPreferenceType || (ContactPreferenceType = {}));
export class PatientErrorDto {
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that caused the error",
    }),
    IsNumber()
], PatientErrorDto.prototype, "patientIndex", void 0);
__decorate([
    ApiProperty({
        description: "Description of the error that occurred while processing this patient",
    }),
    IsString()
], PatientErrorDto.prototype, "error", void 0);
export class PatientDuplicateDto {
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that was a duplicate",
    }),
    IsNumber()
], PatientDuplicateDto.prototype, "patientIndex", void 0);
__decorate([
    ApiProperty({
        description: "ID of the existing patient that was already in the system",
    }),
    IsString()
], PatientDuplicateDto.prototype, "existingPatientId", void 0);
__decorate([
    ApiProperty({
        description: "List of fields that matched the existing patient",
        type: String,
        isArray: true,
    }),
    IsArray(),
    IsString({ each: true })
], PatientDuplicateDto.prototype, "duplicateFields", void 0);
export class PatientSuccessDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that was successfully added",
    }),
    IsNumber()
], PatientSuccessDto.prototype, "patientIndex", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
    }),
    IsString(),
    IsOptional()
], PatientSuccessDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    IsString(),
    IsOptional()
], PatientSuccessDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsString(),
    IsOptional()
], PatientSuccessDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "MRN of the patient",
    }),
    IsString(),
    IsOptional()
], PatientSuccessDto.prototype, "mrn", void 0);
__decorate([
    ApiProperty({
        description: "Reference ID of the patient in HealthEx",
    }),
    IsString()
], PatientSuccessDto.prototype, "referenceId", void 0);
export class AddPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Last name of the patient",
    }),
    IsString(),
    IsNotEmpty()
], AddPatientDto.prototype, "lastName", void 0);
__decorate([
    ApiProperty({
        description: "First name of the patient",
    }),
    IsString(),
    IsNotEmpty()
], AddPatientDto.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsOptional(),
    IsString(),
    Matches(/\S/, { message: EXTERNAL_ID_NOT_EMPTY_MESSAGE })
], AddPatientDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth of the patient",
    }),
    Type(() => Date),
    IsOptional()
], AddPatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
    }),
    ValidateIf((o) => o.email && o.email.length > 0),
    IsEmail()
], AddPatientDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    ValidateIf((o) => o.phone && o.phone.length > 0),
    IsPhoneNumber("US")
], AddPatientDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "MRN of the patient",
    }),
    IsString(),
    IsOptional()
], AddPatientDto.prototype, "mrn", void 0);
__decorate([
    ApiProperty({
        description: "Contact preference of the patient",
        enumName: "ContactPreferenceType",
        enum: ContactPreferenceType,
    }),
    IsEnum(ContactPreferenceType)
], AddPatientDto.prototype, "contactPreference", void 0);
__decorate([
    ApiProperty({
        description: "Language preference of the patient",
        enumName: "StudyTranslationLanguage",
        enum: StudyTranslationLanguage,
    }),
    IsEnum(StudyTranslationLanguage)
], AddPatientDto.prototype, "languagePreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "List of National Provider Identifier (NPI) numbers for the patient's care facilities",
        isArray: true,
    }),
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode)
], AddPatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    ApiPropertyOptional({
        description: "When enabled, allows only facilities that are in the targetedFacilities list",
    }),
    IsBoolean(),
    IsOptional()
], AddPatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
export class AddPatientByMRNDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "MRN of the patient for healthcare organizations",
    }),
    IsString(),
    IsNotEmpty()
], AddPatientByMRNDto.prototype, "mrn", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Patient notification type for the patient. If not provided, defaults to enrollment requested.",
        enumName: "PatientNotificationType",
        enum: PatientNotificationType,
    }),
    IsEnum(PatientNotificationType),
    IsOptional()
], AddPatientByMRNDto.prototype, "patientNotificationType", void 0);
export class AddPatientsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "Array of patients to add to the project",
        type: AddPatientDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AddPatientDto),
    IsOptional()
], AddPatientsInput.prototype, "patients", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of MRNs to add to the project",
        type: AddPatientByMRNDto,
        isArray: true,
    }),
    IsArray(),
    Type(() => AddPatientByMRNDto),
    IsOptional()
], AddPatientsInput.prototype, "mrns", void 0);
export class AddPatientsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Total number of patients processed in the request",
    }),
    IsNumber()
], AddPatientsResponseDto.prototype, "totalProcessed", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients successfully added",
    }),
    IsNumber()
], AddPatientsResponseDto.prototype, "successCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that failed to be added due to validation errors",
    }),
    IsNumber()
], AddPatientsResponseDto.prototype, "errorCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that were duplicates and not added",
    }),
    IsNumber()
], AddPatientsResponseDto.prototype, "duplicatesCount", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of errors that occurred during patient processing",
        type: PatientErrorDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientErrorDto),
    IsOptional()
], AddPatientsResponseDto.prototype, "errors", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of duplicate patients that were not added",
        type: PatientDuplicateDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientDuplicateDto),
    IsOptional()
], AddPatientsResponseDto.prototype, "duplicates", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientSuccessDto),
    IsOptional()
], AddPatientsResponseDto.prototype, "successfulPatients", void 0);
export class CheckPatientExistsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional()
], CheckPatientExistsDto.prototype, "email", void 0);
__decorate([
    IsOptional()
], CheckPatientExistsDto.prototype, "phone", void 0);
__decorate([
    IsOptional(),
    IsString()
], CheckPatientExistsDto.prototype, "externalId", void 0);
export class CheckPatientsExistsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CheckPatientExistsDto)
], CheckPatientsExistsInput.prototype, "patients", void 0);
export class PatientExistsResultDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional()
], PatientExistsResultDto.prototype, "email", void 0);
__decorate([
    IsOptional()
], PatientExistsResultDto.prototype, "phone", void 0);
__decorate([
    IsBoolean()
], PatientExistsResultDto.prototype, "emailExists", void 0);
__decorate([
    IsBoolean()
], PatientExistsResultDto.prototype, "phoneExists", void 0);
__decorate([
    IsBoolean()
], PatientExistsResultDto.prototype, "externalIdExists", void 0);
__decorate([
    IsOptional(),
    IsString()
], PatientExistsResultDto.prototype, "existingPatientId", void 0);
export class CheckPatientsExistsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientExistsResultDto)
], CheckPatientsExistsResponseDto.prototype, "results", void 0);
export class UpdatePatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Reference ID of the patient to update",
    }),
    IsString(),
    IsNotEmpty()
], UpdatePatientDto.prototype, "referenceId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "First name of the patient",
    }),
    IsString(),
    IsOptional()
], UpdatePatientDto.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Last name of the patient",
    }),
    IsString(),
    IsOptional()
], UpdatePatientDto.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsOptional(),
    IsString(),
    Matches(/\S/, { message: EXTERNAL_ID_NOT_EMPTY_MESSAGE })
], UpdatePatientDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
        example: "john.doe@example.com",
    }),
    ValidateIf((o) => o.email && o.email.length > 0),
    IsEmail()
], UpdatePatientDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    ValidateIf((o) => o.phone && o.phone.length > 0),
    IsPhoneNumber("US")
], UpdatePatientDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Contact preference of the patient",
        enumName: "ContactPreferenceType",
        enum: ContactPreferenceType,
    }),
    IsEnum(ContactPreferenceType),
    IsOptional()
], UpdatePatientDto.prototype, "contactPreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Language preference of the patient",
        enumName: "StudyTranslationLanguage",
        enum: StudyTranslationLanguage,
    }),
    IsEnum(StudyTranslationLanguage),
    IsOptional()
], UpdatePatientDto.prototype, "languagePreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Targeted facilities of the patient",
        isArray: true,
    }),
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode)
], UpdatePatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Exclude untargeted facilities of the patient",
    }),
    IsBoolean(),
    IsOptional()
], UpdatePatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
export class UpdatePatientsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Array of patients to update in the project",
        type: UpdatePatientDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => UpdatePatientDto)
], UpdatePatientsInput.prototype, "patients", void 0);
export class UpdatePatientsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Total number of patients processed in the request",
    }),
    IsNumber()
], UpdatePatientsResponseDto.prototype, "totalProcessed", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients successfully updated",
    }),
    IsNumber()
], UpdatePatientsResponseDto.prototype, "successCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that failed to be updated due to validation errors",
    }),
    IsNumber()
], UpdatePatientsResponseDto.prototype, "errorCount", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of errors that occurred during patient processing",
        type: PatientErrorDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientErrorDto),
    IsOptional()
], UpdatePatientsResponseDto.prototype, "errors", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientSuccessDto),
    IsOptional()
], UpdatePatientsResponseDto.prototype, "successfulPatients", void 0);
